<template>
    <v-row class="mx-1">
        <NewEditBusiness v-model="showNewEditBusinessDialog"/>
        <ImporterNew main-color="kbRed" type="users" v-model="showImporterDialog"/>
        <delete-business @clearBusiness="businessToDelete=$event"
                         :business="businessToDelete"
                         v-model="showDeleteBusinessDialog"/>

        <v-col class="text-h6 py-0" cols="12">
            <v-row align="center">
                <v-col cols="12" md="8" class="px-0 pt-0 align-self-stretch">
                    <v-menu :close-on-content-click="false" offset-y v-model="showOptions" max-width="500">
                        <template v-slot:activator="{ on }">
                            <v-text-field :hint="isAdvancedSearch ? $t('general.customizedSearch') : ''"
                                          hide-details
                                          :persistent-hint="isAdvancedSearch"
                                          @input="showOptions = false"
                                          clearable
                                          color="kbDarkBlueText"
                                          :placeholder="$t('general.search')"
                                          v-model="search">
                                <template v-slot:append>
                                    <v-icon color="kbDarkBlueText"
                                            @click="showOptions = !showOptions"
                                            v-on="on">
                                      arrow_drop_down</v-icon>
                                </template>

                                <template v-slot:append-outer>
                                    <v-icon color="kbDarkBlueText" @click="getBusinesses()" class="ml-2">refresh</v-icon>
                                </template>
                            </v-text-field>
                        </template>

                        <!--BUSQUEDA AVANZADA-->

                        <v-card color="kbWhite">
                            <div class="overflow-y-auto" style="max-height: 75vh">
                                <v-card-text>
                                    <v-row class="flex-column">
                                        <v-col cols="12">
                                            <v-text-field color="kbDarkBlueText"
                                                          :label="$t('general.location')"
                                                          v-model="location"/>
                                        </v-col>

                                        <v-col cols="12">
                                            <v-select :items="categories"
                                                      item-color="kbDarkBlueText"
                                                      color="kbDarkBlueText"
                                                      chips
                                                      clearable
                                                      deletable-chips
                                                      dense
                                                      item-text="name"
                                                      item-value="id"
                                                      :label="$t('general.categories')"
                                                      multiple
                                                      v-model="advancedSearch.categories">
                                            </v-select>
                                        </v-col>

                                        <v-col cols="12">
                                            <v-select :items="segments"
                                                      item-color="kbDarkBlueText"
                                                      color="kbDarkBlueText"
                                                      chips
                                                      clearable
                                                      deletable-chips
                                                      dense
                                                      item-text="name"
                                                      item-value="id"
                                                      :label="$t('general.segments')"
                                                      multiple
                                                      v-model="advancedSearch.segments">
                                            </v-select>
                                        </v-col>

                                        <v-col cols="12">
                                            <v-autocomplete :items="otherLabels"
                                                            @click:clear="removeAll()"
                                                            chips
                                                            color="kbDarkBlueText"
                                                            clearable
                                                            deletable-chips
                                                            dense
                                                            item-color="kbDarkBlueText"
                                                            item-text="name"
                                                            item-value="id"
                                                            :label="$t('general.extraData')"
                                                            multiple
                                                            :no-data-text="$t('general.noExtraDataFound')"
                                                            return-object
                                                            v-model="advancedSearch.otherLabelsSelected">

                                                <template v-slot:selection="data">
                                                    <v-chip :input-value="data.selected"
                                                            @click:close="remove(data.item)"
                                                            class="chip--select-multi"
                                                            close>
                                                        {{ data.item }}
                                                    </v-chip>
                                                </template>

                                                <template v-slot:item="{ item, attrs, on }">
                                                    <v-list-item v-on="on">
                                                        <v-list-item-action>
                                                            <v-checkbox v-bind="attrs" class="filter-other-data-item-checkbox"></v-checkbox>
                                                        </v-list-item-action>
                                                        <v-list-item-content @click="removeFromList(item)">
                                                            <v-list-item-title v-html="item"/>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>

                                        <v-col :key="item"
                                               v-for="item in advancedSearch.otherLabelsSelected"
                                               cols="12">
                                            <v-text-field :label="item"
                                                          color="kbDarkBlueText"
                                                          @input="getBusinesses()"
                                                          clearable
                                                          v-model="advancedSearch.otherLabels[item]">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </div>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click="showOptions = false"
                                       color="kbRed"
                                       dark>{{ $t('general.search') }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-menu>
                </v-col>

                <v-col cols="12" md="4" class="d-flex align-end justify-end pt-0 align-self-stretch">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <div v-on="on">
                                <v-btn @click="showImporter()"
                                       color="mainButtons"
                                       outlined>
                                    {{ $t('general.import') }}
                                </v-btn>
                            </div>
                        </template>
                        <span>{{ $t('general.import') }} {{ businessModule.p }}</span>
                    </v-tooltip>

                    <v-btn @click="showNewEditBusinessDialog = true"
                           class="ml-3"
                           dark
                           color="mainButtons">{{ $t('general.addNew') }}</v-btn>
                </v-col>
            </v-row>
        </v-col>

        <v-col class="px-0 pb-0">
            <v-data-table :headers="headers"
                          fixed-header
                          :height="dataTableHeight"
                          :items="businesses"
                          :loading="loadingBusinesses"
                          :options.sync="options"
                          :footer-props="{
                            'items-per-page-text': `${businessModule.p} ${$t('general.perPage')}`,
                            'items-per-page-options': [50, 100, 200]
                          }"
                          :server-items-length="totalBusinesses"
                          class="elevation-1">
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-center">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-avatar :color="item.inactive ? 'success' : 'error'"
                                        size="10" v-on="on"
                                        style="cursor: pointer;"/>
                            </template>
                            <span>{{item.inactive ? $t('general.active') : $t('general.inactive')}}</span>
                        </v-tooltip>
                    </td>
                    <td class="font-weight-bold text-capitalize">
                      <InlineEditor field-type="text"
                                    :value="item.name"
                                    @onSave="updateBusiness(item.UUID, 'name', $event)">
                        <span>
                          {{ item.name.toLowerCase() }}
                        </span>
                      </InlineEditor>
                    </td>
                    <td>
                      <InlineEditor field-type="text"
                                    :value="item.url"
                                    @onSave="updateBusiness(item.UUID, 'url', $event)">
                        <span>
                          {{ item.url }}
                        </span>
                      </InlineEditor>
                    </td>
                    <td>
                      <InlineEditor field-type="email"
                                    :value="item.email"
                                    @onSave="updateBusiness(item.UUID, 'email', $event)">
                        <span>
                          {{ item.email }}
                        </span>
                      </InlineEditor>
                    </td>
                    <td class="px-0 mx-0">
                      <div class="data-table-actions d-flex justify-center align-center">
                        <v-btn @click="showViewBusiness(item)" color="kbDarkBlueText" text icon>
                            <v-icon>remove_red_eye</v-icon>
                        </v-btn>
                        <v-btn @click="deleteBusiness(item)"
                               icon>
                            <v-icon color="kbRed">
                                delete
                            </v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </template>

                <template v-slot:no-data>
                    <v-row>
                        <v-col class="text-center" v-if="loadingBusinesses" cols="12">
                            {{ $t('general.loading') }} {{ businessModule.p }}
                        </v-col>
                        <v-col class="red--text text-center" v-else cols="12">
                            {{ $t('general.noBusinessesCreated', { business: businessModule.p }) }}
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import NewEditBusiness from '@/pages/App/Businesses/dialogs/NewEditBusiness.vue'
import ImporterNew from '@/components/ui/ImporterNew/ImporterNew'
import DeleteBusiness from './dialogs/DeleteBusiness'
import ModuleTableHeight from '@/mixins/ModuleTableHeight'
import notifications from '@/libs/notifications'
export default {
  components: { DeleteBusiness, NewEditBusiness, ImporterNew },
  computed: {
    ...mapState({
      advancedSearch: state => state.businesses.advancedSearch,
      language: state => state.auth.language,
      loadingBusinesses: state => state.businesses.loadingBusinesses,
      paginationBusinesses: state => state.businesses.paginationBusinesses,
      selectedApp: state => state.apps.selectedApp,
      totalBusinesses: state => state.businesses.totalBusinesses,
      businesses: state => state.businesses.businesses
    }),
    ...mapGetters([
      'appUuid',
      'companyUuid',
      'categories',
      'otherLabels',
      'segments',
      'businessModule'
    ]),
    search: {
      get () {
        return this.$store.state.businesses.search
      },
      set (value) {
        this.$store.commit('SET_SEARCH_BUSINESSES', value)
      }
    },
    isAdvancedSearch () {
      return this.advancedSearch.categories.length > 0 ||
                 this.advancedSearch.otherLabelsSelected.length > 0
    },
    isSearching () {
      return this.isAdvancedSearch || (this.search && this.search !== '')
    }
  },
  created () {
    this.$store.dispatch(
      'getApp',
      { appId: this.appUuid, companyId: this.companyUuid, getStatistics: false }
    )
  },
  data () {
    return {
      options: {},
      headers: [
        { text: this.$t('general.state'), value: 'inactive' },
        { text: this.$t('general.name'), value: 'name' },
        { text: 'Url', value: 'url' },
        { text: 'Email', value: 'email' },
        { text: this.$t('general.actions'), align: 'center', value: '', sortable: false }
      ],
      location: '',
      selectedBusiness: {},
      showViewBusinessDialog: false,
      showNewEditBusinessDialog: false,
      showImporterDialog: false,
      showOptions: false,
      showDeleteBusinessDialog: false,
      businessToDelete: ''
    }
  },
  methods: {
    clearSelectedBusiness () {
      this.selectedBusiness = {}
    },
    showViewBusiness (business) {
      this.$router.push(`businesses/${business.UUID}`)
    },
    getBusinesses () {
      this.$store.commit('SET_PAGINATION_BUSINESSES', {
        page: this.options.page,
        itemsPerPage: this.options.itemsPerPage,
        sortBy: this.options.sortBy[0],
        descending: this.options.sortDesc[0]
      })
      this.$store.dispatch('getBusinesses', this.location)
    },
    showImporter () {
      this.showImporterDialog = true
      this.$store.commit('SET_IMPORTER_STEP', 2)
      this.$store.commit('SET_IMPORTER_SELECTION', 'negocio')
    },
    async updateBusiness (businessId, key, value) {
      try {
        const data = {
          businessId
        }

        data[key] = value

        await this.$store.dispatch('updateBusiness', data)
        notifications.success(this.$t('general.businessSuccessfullyEdited', { business: this.businessModule.s }))
        this.getBusinesses()
      } catch (error) {
        this.loading = false
        notifications.error(error.message)
      }
    },
    removeAll () {
      this.$store.commit('CLEAR_OTHER_LABELS')
    },
    removeFromList (item) {
      const index = this.advancedSearch.otherLabelsSelected.indexOf(item)
      if (index >= 0) {
        this.advancedSearch.otherLabelsSelected.splice(index, 1)
        delete this.advancedSearch.otherLabels[item]
      }
      this.getBusinesses()
    },
    remove (item) {
      const index = this.advancedSearch.otherLabelsSelected.indexOf(item)
      if (index >= 0) {
        this.advancedSearch.otherLabelsSelected.splice(index, 1)
        delete this.advancedSearch.otherLabels[item]
      }
      this.getBusinesses()
    },
    deleteBusiness (business) {
      this.showDeleteBusinessDialog = true
      this.businessToDelete = business
    }
  },
  mixins: [ModuleTableHeight],
  watch: {
    language () {
      this.headers[0].text = this.$t('general.state')
      this.headers[1].text = this.$t('general.name')
      this.headers[4].text = this.$t('general.actions')
    },
    options: {
      handler () {
        this.getBusinesses()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    search () {
      this.options.page = 1
      this.$vuetify.goTo(0)
      this.getBusinesses()
    },
    'advancedSearch.otherLabels': function () {
      this.options.page = 1
      this.$vuetify.goTo(0)
      this.getBusinesses()
    },
    'advancedSearch.categories': function () {
      this.options.page = 1
      this.$vuetify.goTo(0)
      this.getBusinesses()
    },
    'advancedSearch.segments': function () {
      this.options.page = 1
      this.$vuetify.goTo(0)
      this.getBusinesses()
    },
    location () {
      this.options.page = 1
      this.$vuetify.goTo(0)
      this.getBusinesses()
    }
  },
  destroyed () {
    this.$store.commit('CLEAR_ADVANCED_SEARCH')
  }
}
</script>
<style>
div.v-menu__content div.filter-other-data-item-checkbox input {
  display: none;
}
</style>
